import React from "react"
import Home from "./home";
import '../styles/app.css';

const IndexPage = () => (
  <Home />
)

export default IndexPage
